module.exports = "<spinner\n  [backgroundColor]=\"'#006bb7'\"\n  [spinner]=\"spinkit.skThreeBounce\"\n  [debounceDelay]=\"200\"\n>\n</spinner>\n<p-growl [(value)]=\"alerta.msgs\" [life]=\"4000\" [sticky]=\"false\"></p-growl>\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main